import { createUseStyles } from "react-jss";

export const ButtonsStyled = createUseStyles((theme: any) => ({
    button: {
        border: "0px",
        borderRadius: theme.borders.button.radius,
        padding: theme.paddings.button.container,
        cursor: "pointer",
        fontSize: theme.fonts.sizes.base,
        fontWeight: theme.fonts.weight.normal,
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.2) 0 0)",
        },
        "&:disabled": {
            opacity: "0.3",
            cursor: "default",
        },
        "&:disabled:hover": {
            opacity: "0.3",
            backgroundImage: "none",
        },
        "& i": {
            verticalAlign: "middle",
            paddingRight: theme.paddings.button.icon,
        },
    },
    primary: {
        background: theme.colors.buttons.primary.background,
        color: theme.colors.buttons.primary.color,
    },
    primaryInverse: {
        background: theme.colors.buttons.primary.color,
        color: theme.colors.buttons.primary.background,
    },
    primaryInverseWithBorder: {
        background: theme.colors.buttons.primary.color,
        color: theme.colors.buttons.primary.background,
        border: `1px solid ${theme.colors.buttons.primary.background}`,
    },
    secondary: {
        background: theme.colors.buttons.secondary.background,
        color: theme.colors.buttons.secondary.color,
    },
    success: {
        background: theme.colors.buttons.success.background,
        color: theme.colors.buttons.success.color,
    },
    danger: {
        background: theme.colors.buttons.danger.background,
        color: theme.colors.buttons.danger.color,
    },
    warning: {
        background: theme.colors.buttons.warning.background,
        color: theme.colors.buttons.warning.color,
    },
    info: {
        background: theme.colors.buttons.info.background,
        color: theme.colors.buttons.info.color,
    },
    dangerInverseWithBorder: {
        color: theme.colors.buttons.danger.background,
        background: theme.colors.buttons.danger.color,
    },
}));
